/**
 * Copyright © 2026 Adnuntius AS.
 *
 * List-page chrome (shell, sort header, pagination, search, undo, new-item action).
 * Feature-local so ...APP_SHARED stays pipes/banners only.
 */
import {ListCountBadgeComponent} from './list-count-badge.component';
import {ListDefaultActionsComponent} from './list-default-actions.component';
import {UndoDeleteComponent} from './html/undo-delete-component';
import {AdnSortingHeaderComponent} from './html/sorting-header.component';
import {AdnPaginationComponent} from './pagination/pagination.component';
import {SearchPaginationComponent} from './pagination/search-pagination.component';
import {SearchListComponent} from './search-list.component';

export const ADMIN_LIST = [
  ListDefaultActionsComponent,
  ListCountBadgeComponent,
  AdnPaginationComponent,
  SearchPaginationComponent,
  SearchListComponent,
  UndoDeleteComponent,
  AdnSortingHeaderComponent
];
